import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";

export const processColdefs = [
    {
        field: "sR.No",
        headerName: "Sr No",
        // minWidth: window.innerWidth * 0.08,
        flex: 0.5,
        filter: true,
    },
    {
        field: "processDetails",
        headerName: "Process details",
        // minWidth: window.innerWidth * 0.08,
        flex: 1.5,
        filter: true,
    },

];

export const ItemWiseProcessPopup = (props) => {
    return (
        <ModalBasic
            id="itemWiseProcess"
            classParams="!w-[75%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Product selection</span>
                <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200'>
                    <div className='input-grp'>
                        <label>Sr no.</label>
                        <TextInput type='number'
                            id='srNo' name='srNo'
                            value={props.itemObject.srNo}
                            handleChange={(event) => props.handleChange(event, 'srNo')}
                            disabled
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select category</label>
                        <MultiSelectDropdown
                            drpIdentity="Select category"
                            options={props.itemObject.selectCategoryList}
                            value={props.itemObject.selectCategoryId ? props.itemObject.selectCategoryList.find(x => x.value === props.itemObject.selectCategoryId) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "selectCategoryId")
                            }
                            className={props.validState?.error?.selectCategoryId !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select item</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select item"
                            options={props.itemObject.selectItemList}
                            value={props.itemObject.idItem ? props.itemObject.selectItemList.find(x => x.value === props.itemObject.idItem) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "idItem")
                            }
                            className={props.validState?.error?.idItem !== undefined ? "error" : ""}
                        /> */}
                        <TextInput
                            id="SelectItem"
                            name="SelectItem"
                            value={props.itemObject.ItemLabel}
                            handleOnClick={(event) => props.handleOnClick(event, "selectItemList")}
                        // className={props.validState?.error?.chequeBookSeries !== undefined ? "error" : ""}
                        />
                    </div>
                </div>
                <span className="text-blue text-[16px] font-semibold">Process details</span>
                <div className='item-grp grid grid-cols-3 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp col-span-2'>
                        <label>Select process</label>
                        <MultiSelectDropdown
                            drpIdentity="Select process"
                            options={props.itemObject.selectProcessList}
                            value={props.itemObject.selectProcessId ? props.itemObject.selectProcessList.find(x => x.value === props.itemObject.selectProcessId) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "selectProcessId")
                            }
                            className={props.validState?.error?.selectProcessId !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        {props.itemObject.keyId > 0 ?
                            <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.insert("Update")}>Update</button>
                            :
                            <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.insert("Insert")}>Insert</button>
                        }
                        {props.itemObject.sequenceNo > 0 ?
                            <button className="delete-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.Delete(props.itemObject.sequenceNo)}>Delete</button>
                            :
                            null
                        }

                    </div>
                </div>
                <div className="process-table h-[30vh] pb-[8px]">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.itemObject.itemList}
                            columnDefs={props.itemObject.processColdefs}
                            onRowDoubleClicked={props.handleCellClickItemList}
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}